import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// Old invitation links (/invite?code=…) land on the student sign-up page,
// which reads the same `code` parameter (StudentRegisterPage).
const InviteRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={`/register/student${search}`} replace />;
};

export default InviteRedirect;
